import "./styles/main.scss"
import Atom from "./components/Atom.svelte"

// enable this when creating an atom for the article template
// import '$lib/helpers/resizeFrame';

// create scrollbar width CSS variable
import "$lib/helpers/scrollbarWidth";


import { hydrate, mount } from "svelte"

let isAndroid = document.querySelector("body").classList.contains("android")

let app

if (!isAndroid) {
  app = hydrate(Atom, {
    target: document.getElementById("gv-atom"),
  })
} else {
  // Android doesn't support hydrate - reads hydration markers differently to other browser engines
  let atomEl = document.getElementById("gv-atom");
  atomEl.innerHTML = "";
  app = mount(Atom, {
    target: document.getElementById("gv-atom"),
  })
}


export default app